/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_Drop_FrameInputs */

const en_target_drop_frame = /** @type {(inputs: Target_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Drop Frame`)
};

const fr_target_drop_frame = /** @type {(inputs: Target_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop frame cible`)
};

const de_target_drop_frame = /** @type {(inputs: Target_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel-Fallrahmen`)
};

const it_target_drop_frame = /** @type {(inputs: Target_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telaio di caduta del bersaglio`)
};

const ru_target_drop_frame = /** @type {(inputs: Target_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевой кадр с падением`)
};

const es_target_drop_frame = /** @type {(inputs: Target_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco de caída de objetivo`)
};

const zh_cn2_target_drop_frame = /** @type {(inputs: Target_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标掉帧`)
};

const ja_target_drop_frame = /** @type {(inputs: Target_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターゲットドロップフレーム`)
};

const hi_target_drop_frame = /** @type {(inputs: Target_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टारगेट ड्रॉप फ्रेम`)
};

const pt_pt2_target_drop_frame = /** @type {(inputs: Target_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moldura de queda do alvo`)
};

/**
* | output |
* | --- |
* | "Target Drop Frame" |
*
* @param {Target_Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_drop_frame = /** @type {((inputs?: Target_Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_target_drop_frame(inputs)
	if (locale === "de") return de_target_drop_frame(inputs)
	if (locale === "it") return it_target_drop_frame(inputs)
	if (locale === "ru") return ru_target_drop_frame(inputs)
	if (locale === "es") return es_target_drop_frame(inputs)
	if (locale === "zh-CN") return zh_cn2_target_drop_frame(inputs)
	if (locale === "ja") return ja_target_drop_frame(inputs)
	if (locale === "hi") return hi_target_drop_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_target_drop_frame(inputs)
	return en_target_drop_frame(inputs)
});